import React from 'react';
import {CardGroup, Card} from 'react-bootstrap';

import "./BrandLogos.css";


function BrandLogos(props) {
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
        let cardClass;
        if (vw < 576) {
            cardClass="hide-me";
        } else {
            cardClass="show-me";
        }
    return (
        
        <CardGroup className={cardClass} style={{marginTop:"1rem"}}>
            {props.srcArray.map((src, index) => {
                return (
                    <Card style={{borderStyle:"none"}} className="brand-card">
                        <div className="brand-card-image-container">
                            <Card.Img variant="" src={src} key={index} />
                        </div>
                    </Card>
                )
            })}
        </CardGroup>
    )
}

export default BrandLogos;   